import React from "react";
import JoinUs from "../NewHomePage/JoinUs";
import { BookSlot } from "../RegistrationForm/BookSlot";
import Footer from "../Component/Footer";
import { WhatWeStandFor } from "../NewHomePage/WhatWeStandFor";
import { BadmintonBenefits } from "./BadmintonBenefits";
import { Kosmos } from "./kosmos";
import StickyHeader from "./StickyHeader";
import { BadmintonAcademy } from "./BadmintonAcademy";

export const NewHomePage = () => {
  return (
    <div>
      <StickyHeader />
      <Kosmos />
      <BadmintonBenefits />
      <BadmintonAcademy />
      <WhatWeStandFor />
      <JoinUs />
      <BookSlot />
      <Footer />
    </div>
  );
};
